// Install panel — MOBILE tab: QR block, store picker and store badges.
import { useState } from "react";
import styles from "../Connect.module.css";
import PlatformOption from "./PlatformOption";
import { QrPlaceholder, PlayMark, AppleMark, AndroidMark } from "./ConnectIcons";

const MOBILE_PLATFORMS = [
  { id: "android", label: "Android" },
  { id: "ios", label: "iOS" },
];

// Each row carries its own platform mark, the way the desktop tab does. Both
// rows previously shared one generic shield, which made the picker read as two
// copies of the same option.
const ICONS = {
  android: <AndroidMark size={18} />,
  ios: <AppleMark size={18} />,
};

export default function MobileInstall() {
  const [selected, setSelected] = useState(MOBILE_PLATFORMS[0].id);

  return (
    <>
      <span className={styles.kicker}>CHOOSE YOUR PLATFORM</span>
      <h3 className={styles.sectionTitle}>Get the Mobile app</h3>
      <p className={styles.sectionDesc}>
        Install PQ VPN on your work Mobile to start and manage the protected tunnel.
      </p>

      <div className={styles.qrBlock}>
        <div className={styles.qrCode}>
          <QrPlaceholder size={272} />
        </div>

        <div className={styles.qrSide}>
          <p className={styles.qrHint}>
            Select your platform and scan the QR code for quick app access.
          </p>

          <div className={styles.platformList}>
            {MOBILE_PLATFORMS.map((p) => (
              <PlatformOption
                key={p.id}
                label={p.label}
                icon={ICONS[p.id]}
                selected={selected === p.id}
                onSelect={() => setSelected(p.id)}
              />
            ))}
          </div>

          <div className={styles.storeRow}>
            <button type="button" className={styles.storeBadge}>
              <PlayMark size={22} />
              <span className={styles.storeText}>
                <span className={styles.storeKicker}>GET IT ON</span>
                <span className={styles.storeName}>Google Play</span>
              </span>
            </button>
            <button type="button" className={styles.storeBadge}>
              <AppleMark size={22} />
              <span className={styles.storeText}>
                <span className={styles.storeKicker}>Download on the</span>
                <span className={styles.storeName}>App Store</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
